import React, { Component, createRef } from 'react';
import debounce from 'lodash.debounce';

import { ViewportContext } from './ViewportContext';
import CreateStorySection from './sections/CreateStory';
import CreateLifelineSection from './sections/CreateLifeline';
import AnimatedPhotos from './sections/AnimatedPhotos';
import ClaimSection from './sections/Claim';
import PhotosSection from './sections/Photos';
import GetStartedFreeAccount from './sections/GetStartedFreeAccount'; // **jc**
import Container from '@/components/Container';
import LifelineShape from '@/components/LifelineShape';
import config from '@/config';
import choose from '@/utils/choose';
import isSSR from '@/utils/isSSR';

import { lifelinesData } from '@/components/LifelineShape/datasets';

import { wide } from '@/components/App/breakpoints';

import './style.css';

export default class Homepage extends Component {
  state = {
    index: -1,
    mobile: false,
    lifelineData: choose(lifelinesData),
  };

  static backgroundColors = {
    0: 'var(--white)',
    1: 'var(--scooter)',
    2: 'var(--white)',
    3: 'var(--pinkish)',
    4: 'var(--white)', // **jc**
  };

  constructor(props) {
    super(props);
    this.cloudComponent = createRef();
    this.background = createRef();
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.checkScreenSize();

    const headerHeightPx =
      10 *
      parseFloat(
        window
          .getComputedStyle(document.documentElement)
          .getPropertyValue('--header-height')
      );

    const fullThreshold = 1 - headerHeightPx / window.innerHeight;

    this.sectionObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const index = parseInt(entry.target.dataset.index, 10);
          const threshold = parseFloat(entry.target.dataset.threshold || '0.5');

          if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
            const color = Homepage.backgroundColors[index];
            this.setBackgroundColor(color);

            this.setState({ index: index });
          }
        });
      },
      { threshold: [0.5, fullThreshold] }
    );

    const sections = document.querySelectorAll('.beacon');
    sections.forEach(section => {
      this.sectionObserver.observe(section);
    });

    window.addEventListener('resize', this.checkScreenSize);

    setTimeout(() => {
      this.setState({ index: 0 });
    }, 500);
  }

  checkScreenSize = debounce(() => {
    this.setState({
      mobile: window.innerWidth < wide,
    });
  }, 250);

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
    this.sectionObserver.disconnect();
  }

  setBackgroundColor = color => {
    if (!this.background.current) {
      return;
    }

    function getColorValue(name) {
      if (!name.includes('var(')) {
        return name;
      }
      return window
        .getComputedStyle(document.documentElement)
        .getPropertyValue(name.replace('var(', '').replace(')', ''))
        .trim();
    }

    this.background.current.style.backgroundColor = color;

    if (!this.cloudComponent.current) {
      return;
    }

    switch (color) {
      case 'transparent':
        this.cloudComponent.current.bg_color = 'rgb(255, 255, 255)';
        break;
      default:
        this.cloudComponent.current.bg_color = getColorValue(color);
    }
  };

  updateIndex = value => {
    /*const color = Homepage.backgroundColors[value];
    this.setBackgroundColor(color);

    this.setState({ index: value });*/

    if (this.state.index === value) {
      return;
    }

    let beacon = document.querySelector(`.beacon[data-index="${value}"]`);
    beacon.scrollIntoView();
  };

  render() {
    const { index, lifelineData } = this.state;

    return (
      <div className="homepage">
        <ViewportContext.Provider value={{ isMobile: this.state.mobile }}>
          <AnimatedPhotos
            visible={index === 1}
            isMobile={this.state.mobile}
            pxStart={1036}
            pxDuration={
              isSSR ? 1600 : window.innerHeight * (this.state.mobile ? 4 : 2.4)
            }
          />

          <div
            className="background background--animated"
            ref={this.background}
          />

          <LifelineShape
            data={lifelineData}
            lines={false}
            outputCloud={true}
            cloud={300}
            ref={this.cloudComponent}
            className="cloud--visible"
            transparent
          />

          <Container size="large">
            <ClaimSection
              visible={index === 0}
              beaconIndex={0}
              lifelineData={lifelineData}
              onButtonFocus={this.updateIndex}
            />
            <PhotosSection visible={index === 1} beaconIndex={1} />
            <CreateLifelineSection
              visible={index === 2}
              beaconIndex={2}
              onButtonFocus={this.updateIndex}
            />
            <CreateStorySection
              visible={index === 3}
              beaconIndex={3}
              showSlider={this.state.mobile}
              onButtonFocus={this.updateIndex}
            />
            {config.isPaidPlanEnabled && (
              <GetStartedFreeAccount
                visible={index === 4}
                beaconIndex={4}
                onButtonFocus={this.updateIndex}
              />
            )}
          </Container>
        </ViewportContext.Provider>
      </div>
    );
  }
}
